<section class="w3l-form-25">
  <div class="form-inner-cont">
    <div class="w3l-form-25">
      <h1>Admin's Reports</h1>
      <p>Choose Report from admins Report list</p>
    </div>
  </div>
</section>

<div id="w3l-appointment">
  <section class="appointment-section section-gap">
    <div class="wrapper">
      <div class="d-grid doctor-appointment">
        <div class="appointment-form">
          <form action="#" method="post">
            <div class="fields-grid">

              <mat-chip-list >
                <a    (click)="ReportDoctor()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'1. Print doctors master data' | translate }}</mat-chip></a>
              </mat-chip-list>

              <mat-chip-list >
                <a    (click)="ReportSuppliers()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'2. Print suppliers master data' | translate }}</mat-chip></a>
              </mat-chip-list>
              <mat-chip-list >
                <a    style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'3. Print Users master data' | translate }}</mat-chip></a>
              </mat-chip-list>
              <mat-chip-list >
                <a (click)="ReportRooms()"   style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'4. Print Treatment rooms master data' | translate }}</mat-chip></a>
              </mat-chip-list>
              <mat-chip-list >
                <a href="Home"  style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-home" style='color:rgb(255, 255, 255)'></i>  {{'Home' | translate }}</mat-chip></a>
              </mat-chip-list>

              <div class="clear"></div>
            </div>
          </form>
        </div>

        <div class="registerimg">
          <img src="assets/images/report1.jpg" alt="" />
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </section>
</div>
